import { render, staticRenderFns } from "./IconExternalLink.vue?vue&type=template&id=d82bb3b6"
import script from "./IconExternalLink.vue?vue&type=script&lang=js"
export * from "./IconExternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports